module.exports = __webpack_public_path__ + "img/facility.405827d1.svg";